module.exports = __webpack_public_path__ + "1920b6bfbdd8e87dcf9c4d105799931d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/backgrounds/flowers.png
// module id = 2748
// module chunks = 0